// context/RolesContext.jsx
import React, { createContext, useContext, useEffect, useState } from "react";
import axiosInstance from "../api/axiosInstance";
import { useAuth } from "./AuthContext";

const RolesCtx = createContext({ roles: [], loading: false });

export const RolesProvider = ({ children }) => {
  const { authData } = useAuth();
  const [roles, setRoles] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const load = async () => {
      if (!authData?.hotelId) { setRoles([]); return; }
      try {
        setLoading(true);
        const res = await axiosInstance.get("/roles", {
          params: { hotelId: authData.hotelId },
        });
        setRoles(Array.isArray(res.data) ? res.data : []);
      } catch {
        setRoles([]);
      } finally {
        setLoading(false);
      }
    };
    load();
  }, [authData?.hotelId]);

  return (
    <RolesCtx.Provider value={{ roles, loading }}>
      {children}
    </RolesCtx.Provider>
  );
};

export const useRoles = () => useContext(RolesCtx);
